export default {
  mode: 'basic',
};
